// extracted by mini-css-extract-plugin
export default {"navItem":"NavItem_navItem__qsZvx","link":"NavItem_link__CeEPl","icon":"NavItem_icon__fl14z","label":"NavItem_label__8ApcX","active":"NavItem_active__tWYfO"};